import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { datadogRum } from '@datadog/browser-rum';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


if (environment.production) {
  datadogRum.init({
    applicationId: environment.datadog.applicationId,
    clientToken: environment.datadog.clientToken,
    site: environment.datadog.site,
    service: environment.datadog.service,
    env: environment.datadog.env,
    sessionSampleRate: environment.datadog.sessionSampleRate,
    sessionReplaySampleRate: environment.datadog.sessionReplaySampleRate,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
